/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable, inject } from '@angular/core';
import { AbstractGenFirestoreService } from '@res/ngg-core';

import { OrmService, Schema } from '../schema/schema.interface';

@Injectable({
  providedIn: 'root',
  deps: [],
})
export class VehicleFirestoreService extends AbstractGenFirestoreService<Schema, 'vehicles'> {
  constructor() {
    super(inject(OrmService).vehicleCollection);
  }
}
